// components/ContactMe.js
import React from 'react';
import '../../styles/HomePage/contact.css';

function ContactMe() {
  return (
    <section id="contact" className="homecontact">
      <div className="cta-container">
        <div className="cta-text">
          <p className="cta-subtitle">START NOW</p>
          <h2 className="cta-heading">Get Start For Free No Credit Card Required</h2>

          <form className="cta-form" onSubmit={(e) => e.preventDefault()}>
            <input type="email" placeholder="Email address" required />
            <button type="submit">Get Started</button>
          </form>

          <p className="cta-link-text">
            Want to contact our team and book a call?{' '}
            <a href="#contact" className="cta-link">Try it now</a>
          </p>
        </div>
        <div className="cta-image">
          <img src='https://techno.websitelayout.net/img/portfolio/portfolio-03.jpg' alt="Team" />
        </div>
      </div>
    </section>
  );
}

export default ContactMe;
